<template>
    <div id="accessStoreInfo" ref="accessStoreInfo">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart no-print"  style="width: 20%;">
            <p class="headerT">库存盘点信息</p>
            <el-form ref="returnForm" :model="returnForm" id="test"  label-width="120px" :label-position="labelPosition">
                <el-form-item label="盘点编号:">
                    <el-input :disabled="true" :value="returnForm.code"></el-input>
                    <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.code,$event)"></i>
                </el-form-item>
                <el-form-item label="盘点类型:">
                    <el-input :disabled="true" v-model="returnForm.verificationType"></el-input>
                </el-form-item>
                <el-form-item label="盘点仓库/工程师:">
                    <el-input :disabled="true" v-model="returnForm.name" ></el-input>
                </el-form-item>
                <el-form-item label="操作人:">
                    <el-input :disabled="true" v-model="returnForm.staffName" ></el-input>
                </el-form-item>
                <el-form-item label="提交时间:">
                    <el-input :disabled="true" v-model="returnForm.createTime" ></el-input>
                </el-form-item>
                <el-form-item label="盘点备注:">
                    <el-input :disabled="true" v-model="returnForm.memo" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr"  style="width: 78%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    id="table"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :summary-method="getSummaries"
                    show-summary
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        type="index"
                        width="50"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">待盘点</span>
                            <span v-else>已盘点</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inventoryQuantity"
                        width="100"
                        label="库存数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="verificationQuantity"
                        width="100"
                        label="盘点数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="profitLoss"
                        width="100"
                        label="盘点损益差">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
        </el-col>        
        <!-- 查看序列号弹出框 -->
        <el-dialog  class="dialog-content" :visible.sync="dialogTableVisible">
            <el-button type="success" size="small" style="margin-bottom:10px">损益差序列号</el-button>
            <el-row 
                class="dialog-code-content" 
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading">
                <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
                    <p>{{item}}</p>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        verificationDetailInfo,
        verificationDetailList
    } from "../../api/api";
    export default {
        name: 'accessStoreInfo',
        components: {},
        data () {
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                orderId:'',
                labelPosition:'left',
                returnForm:{},
                returnData: [],
                dialogTableVisible: false, //弹出框
                checkCodeList:[]  //序列号数组
            }
        },
        created:function(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.orderId) {
                var userOrderId = sessionStorage.getItem('saveOrderId');
                this.orderId = JSON.parse(userOrderId);
            }else{
                let orderId = this.$route.query.orderId
                this.orderId = orderId
            }
            this.getVerificationDetailInfo() //获取出入库信息
            this.getVerificationDetailList() //获取物料信息
           
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getVerificationDetailList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getVerificationDetailList()
            },
            //获取订单详情
            getVerificationDetailInfo() {
                let para={
                    id: this.orderId
                }
                verificationDetailInfo(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnForm = res.data.results
                        this.returnForm.verificationType = (this.returnForm.verificationType == 1) ? '仓库盘点' : '工程师盘点';
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime)
                        sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.id));
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取订单详情分页
            getVerificationDetailList() {
                let para={
                    verificationId: this.orderId,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                verificationDetailList(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                        this.returnData.forEach((item,index)=>{
                            if(item.profitLossNum != null && item.profitLossNum.length != ''){
                                let arr = item.profitLossNum.split(',');
                                arr.forEach((item1,index1)=>{
                                    if(item1 == "" || typeof(item1) == "undefined"){
                                        arr.splice(index1,1);                                                 
                                    }
                                })
                                let obj = {
                                    materialCode:item.materialCode,
                                    materialName:item.materialName,
                                    list:arr
                                }
                                this.returnData[index].list = arr;
                            }
                            
                        })
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查看序列号
            showSerialNumber(index, row) {
                this.checkCodeList = Object.assign({}, row).list
                if(this.checkCodeList != undefined){
                    this.dialogTableVisible = true
                }else{
                    this.$message({
                        message: '当前物料还未添加序列号，请添加后再查看',
                        type: "warning"
                    });
                }
            },
            //复制内容
            handleCopy(text, event) {
                clip(text, event)
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/stockCheck'
                })
            },
            refresh() {
                this.getVerificationDetailList()
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index < 5) {
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                // if (sums[6] > 0) {
                //     sums[7] = this.toThousands2(sums[6]);
                // }
                return sums;
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            }
            
        },
        computed: {
        },
        watch: {},
    }
</script>


<style type="text/css" lang="scss" scoped>
    #accessStoreInfo{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
            .childSpan{padding-left: 20px;margin-bottom: 5px;}
            .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
            .childSpan span.orderId{color: #3399FF;}
            .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
                background-color: #1abc9c;margin: 0px 15px 0px -5px;}
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
    .dialog-content{
        margin:0 auto;
        .el-dialog{
            width:100%
        }
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }
                
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// stockCheckInfo.vue?acce416c